<template>
  <div>
    <v-layout wrap>
      <v-flex xs12>
        <v-btn @click="close" x-small outlined class="mt-2 mb-3 primary white--text">
          <v-icon x-small class="mr-2">mdi-arrow-left</v-icon>{{ $t('1') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 mt-1>
        <v-layout wrap>
          <v-flex x8>
            <b style="font-size:1.4em">{{ $t('2') }}</b>
            <!-- <v-chip color="orange" class="white--text ml-1 mb-6" x-small><v-icon class="mr-1" x-small>mdi-shimmer</v-icon>{{ $t('2bis') }}</v-chip> -->
          </v-flex>
          <v-flex xs4 text-end pr-6 pt-1>
            <span @click="isShowingVideoDialog = true" style="cursor:hand">
              <v-icon small style="padding-bottom: 2px">mdi-play-circle</v-icon>
              <span class="ml-1 textAsLink">{{ $t('video0') }}</span>
            </span>
          </v-flex>
        </v-layout>
        <div><b>{{ $t('3') }}</b></div>
        <div><span v-html="$t('4')"/></div>
        <div class="mt-4"><b>{{ $t('6') }}</b></div>
        <div v-if="isCurrentProfileExperienceEmpty">
          <div>{{ $t('7bis') }}</div>
          <div>{{ $t('8bis') }}</div>
        </div>
        <div v-else>
          <div>{{ $t('7') }}</div>
          <div>{{ $t('8') }}</div>
        </div>
      </v-flex>
      <v-flex xs12>
        <div v-if="errorWhileParsing" class="orange--text mt-2">
          <div>{{ $t('9') }}</div>
          <div v-if="errorWhileParsingErrorType === 'too_many_tokens'">
            {{ $t('10b') }}
          </div>
          <div v-else>
            {{ $t('10') }}
          </div>
        </div>
      </v-flex>
      <v-flex xs12 mt-4>
        <div class="text-end">
          <v-btn style="position: absolute; right: 27px; margin-top: 10px; z-index:0" @click="parse" :disabled="!entireExperienceQuillStr.trim() || isParsingPending" class="secondary mr-4">{{ $t('11') }}</v-btn>
        </div>
        <div class="text-left">
            <v-tooltip top class="buttonOfTooltip">
              <template v-slot:activator="{ on, attrs }">
                <v-btn style="position: absolute; left: 100px; margin-top: 17px" text class="primary--text" @click="resetAllIndents" x-small elevation="0" v-bind="attrs" v-on="on">
                  <v-icon class="img-horizontal-flip">mdi-playlist-remove</v-icon>
                </v-btn>
              </template>
              <small>{{ $t('resetAllIndents') }}</small>
            </v-tooltip>
          </div>
      </v-flex>
    </v-layout>
    <div class="mt-1 mb-6">
      <vue-editor ref="editor" v-model="entireExperienceQuillStr" :editorToolbar="editorToolbar" :editorOptions="editorOptions"></vue-editor>  
    </div>

    <v-dialog v-model="isParsingPending" width="40%" persistent content-class="vDialogWithoutShadow">
      <v-layout wrap mb-6>
        <v-flex xs12 text-center>
          <v-avatar :size="225" color="primary">
            <img :src="images.main" class="mb-1">
          </v-avatar>
        </v-flex>
      </v-layout>
      <v-card class="px-6 pb-4 pt-4 text-center primary white--text">
        <div><b>{{ $t('12') }}</b></div>
        <v-progress-linear indeterminate color="secondary" class="mt-3"></v-progress-linear>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isShowingVideoDialog" height="90%" width="80%">
      <v-card class="pa-2 text-center" v-if="isShowingVideoDialog">
        <h3 class="mb-2 mt-2">{{ $t('video1') }}</h3>
        <video
          controls
          loop
          autoplay
          width="100%"
          height="600px"
          src="https://firebasestorage.googleapis.com/v0/b/esnwebservices-prod.appspot.com/o/public%2FExtraction%20d'une%20expe%CC%81rience.mov?alt=media&token=c943cd65-791d-4a3f-a08e-e85577b76f86"
        />
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import { VueEditor } from "vue2-editor";

const functionsUrlBase = {
  'localhost': 'http://localhost:5001/esnwebservices-dev/us-central1',
  'esnwebservices-dev.firebaseapp.com': 'https://europe-west1-esnwebservices-dev.cloudfunctions.net',
  'esnwebservices-prod.firebaseapp.com': 'https://europe-west1-esnwebservices-prod.cloudfunctions.net',
  'esnwebservices.com': 'https://europe-west1-esnwebservices-prod.cloudfunctions.net'
}[window.location.hostname]

export default {
  components: {
    VueEditor
  },
  props: {
    profile: Object,
    index: Number,
    isFromToken: Boolean
  },
  data: () => ({
    entireExperienceQuillStr: '',
    editorToolbar: [[{ list: "bullet" }]],
    editorOptions: {
      formats: ['list', 'indent'],
      modules: { keyboard: { bindings: { 'tab': { key: 9, handler: function() { return false; } } } } }
    },
    isParsingPending: false,
    errorWhileParsing: false,
    errorWhileParsingErrorType: null,
    images: {
      main: require('@/assets/app/images/Science_Outline.svg')
    },
    isShowingVideoDialog: false
  }),
  computed:{
    isCurrentProfileExperienceEmpty() {
      const xp = this.profile.experiences[this.index] 
      return !xp.startDate && !xp.endDate && !xp.company && !xp.title && !xp.description && !xp.technicalEnv
    }
  },
  methods: {
    async parse() {
      this.errorWhileParsing = false
      this.errorWhileParsingErrorType = null
      this.isParsingPending = true
      let experience;
      if (this.isFromToken) {
        const response = await axios.post(`${functionsUrlBase}/parseEntireExperienceFromToken?dossierId=${this.$route.params.dossierId}&accessToken=${this.$route.query.accessToken}`, {
          entireExperienceQuillStr: this.entireExperienceQuillStr
        })
        if (response.data.success) {
          experience = response.data.experience
        } else {
          this.errorWhileParsing = true
          this.errorWhileParsingErrorType = response.data.errorType
          this.isParsingPending = false
          return;
        }
      } else {
        const response = (await this.$functions.httpsCallable('parseEntireExperience')({
          entireExperienceQuillStr: this.entireExperienceQuillStr,
          dossierId: this.$route.params.dossierId
        }))
        if (response.data.success) {
          experience = response.data.experience
        } else {
          this.errorWhileParsing = true
          this.errorWhileParsingErrorType = response.data.errorType
          this.isParsingPending = false
          return;
        }
      }
      this.profile.experiences[this.index] = experience
      this.close()
      this.isParsingPending = false
    },
    close() {
      this.$emit('setIsUsingSelectEntireExperience', { isUsingSelectEntireExperience: false } )
    },

    resetAllIndents() {
      this.entireExperienceQuillStr = this.entireExperienceQuillStr
        // Convert all paragraphs to indent lvl 0
        .replace(/<p>/g, '<ul><li class="ql-indent-0">')
        .replace(/<\/p>/g, '</li></ul>')
        .replace(/<ul><\/ul>/g, '')
        // Convert all bulletpoints to indent lvl 0
        .replace(/(<li class="ql-indent-)\d(">)/g, '<li class="ql-indent-0">')
        // Convert all empty bulletpoint to empty paragraph
        .replace(/<li class="ql-indent-0"><br><\/li>/g, '</ul><p><br></p><ul>')
        .replace(/<ul><\/ul>/g, '')
    }
  },
  watch: {
    entireExperienceQuillStr: {
      handler(val) {
        if (val.includes('<li>')) {
          this.entireExperienceQuillStr = val.replace(/<li>/g, '<li class="ql-indent-0">')
        }
      }
    }
  }
}
</script>



<i18n>
{
  "fr": {
    "1": "Revenir au formulaire",
    "2": "Extraction d'une expérience",
    "2bis": "Beta",
    "3": "Copiez-collez toute l'expérience",
    "4": "<span>Copiez dans le CV original <b>tout le texte</b> lié à cette expérience, puis collez-le ci-dessous.</span>",
    "6": "Puis cliquez sur \"Extraire\"",
    "7": "Notre algorithme va identifier tous les champs de l'expérience à partir de son texte.",
    "8": "Tous les champs existants seront écrasés : dates, entreprise, titre, description et environnement technique.",
    "7bis": "Notre algorithme va identifier tous les champs de l'expérience à partir de son texte :",
    "8bis": "date de début, date de fin, entreprise, titre, description et environnement technique.",
    "9": "Erreur lors de l'extraction de l'expérience.",
    "10": "Sincèrement désolé. Nous améliorons la fonctionnalité après chaque erreur comme celle-ci.",
    "10b": "Le texte sélectionné est trop long.",
    "11": "Extraire",
    "12": "Analyse de l'expérience en cours...",
    "video0": "Voir un exemple",
    "video1": "Comment sélectionner une expérience d'un seul coup",
    "resetAllIndents": "Réaligner toutes les indentations en bulletpoints de niveau 1"
  },
  "en": {
    "1": "Back to the form",
    "2": "Extraction of an experience",
    "2bis": "Beta",
    "3": "Copy-paste the entire experience",
    "4": "<span>Copy in the original CV <b>all the text</b> related to this experience, then paste it below.</span>",
    "6": "Then click on \"Extract\"",
    "7": "Our algorithm will identify all the fields of the experience from its text.",
    "8": "All the existing fields will be overwritten: dates, company, title, description and technical environment.",
    "7bis": "Our algorithm will identify all the fields of the experience from its text:",
    "8bis": "start date, end date, company, title, description and technical environment.",
    "9": "Error while extracting the experience.",
    "10": "Sorry about that. We improve this feature after each error like this one.",
    "10b": "The selected text is too long.",
    "11": "Extract",
    "12": "Analyzing the experience...",
    "video0": "See an example",
    "video1": "How to extract an entire experience at once",
    "resetAllIndents": "Re-align all the indents into level 1 bulletpoints"
  }
}
</i18n>